var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _TeamMatch = _interopRequireDefault(require("./TeamMatch"));

var _RelatedMatch = _interopRequireDefault(require("./RelatedMatch"));

var _Betting = _interopRequireDefault(require("../Betting"));

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _Basic = require("../../../elements/Basic");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Match/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Match = function (_React$Component) {
  (0, _inherits2.default)(Match, _React$Component);

  var _super = _createSuper(Match);

  function Match() {
    (0, _classCallCheck2.default)(this, Match);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Match, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          match = _this$props.match,
          onPress = _this$props.onPress,
          trackBwin = _this$props.trackBwin,
          onOutboundLinkClick = _this$props.onOutboundLinkClick,
          bettingProviderLogo = _this$props.bettingProviderLogo,
          pageId = _this$props.pageId,
          href = _this$props.href,
          NavWrapper = _this$props.NavWrapper,
          invertTeamAlignment = _this$props.invertTeamAlignment;
      if (!Object.keys(match).length) return null;
      return _react.default.createElement(_Basic.View, {
        mb: 2,
        borderX: 1,
        borderY: 1,
        borderColor: "border.main",
        position: "relative",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41,
          columnNumber: 13
        }
      }, _react.default.createElement(_Touchable.default, {
        NavWrapper: NavWrapper,
        onPress: onPress,
        href: href,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42,
          columnNumber: 17
        }
      }, _react.default.createElement(_TeamMatch.default, (0, _extends2.default)({}, match, {
        invertTeamAlignment: invertTeamAlignment,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 21
        }
      }))), match.quotes ? _react.default.createElement(_Betting.default, (0, _extends2.default)({
        mt: match.isLive ? 2 : 0,
        mb: 2,
        competition: (0, _get.default)(match, 'competition'),
        trackBwin: trackBwin,
        onPress: onOutboundLinkClick,
        providerLogo: bettingProviderLogo,
        pageId: pageId
      }, match, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46,
          columnNumber: 21
        }
      })) : null, match.relatedMatch ? _react.default.createElement(_RelatedMatch.default, (0, _extends2.default)({
        borderX: 0,
        mb: 0
      }, match.relatedMatch, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 21
        }
      })) : null);
    }
  }]);
  return Match;
}(_react.default.Component);

Match.propTypes = {
  match: _propTypes.default.object.isRequired,
  onPress: _propTypes.default.func,
  trackBwin: _propTypes.default.func,
  onOutboundLinkClick: _propTypes.default.func,
  bettingProviderLogo: _propTypes.default.object,
  pageId: _propTypes.default.string,
  NavWrapper: _propTypes.default.func,
  invertTeamAlignment: _propTypes.default.bool
};
var _default = Match;
exports.default = _default;